import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import axiosInstance from "../../utils/axiosInstance";

export const nomineeApi = createAsyncThunk("nominee", async () => {
  const response = await axiosInstance.get("/nominee");
  return response.data;
});

const nomineeSlice = createSlice({
  name: "nominee",
  initialState: {
    nominee: [],
    errors: [],
    loading: false,
  },
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(nomineeApi.pending, (state) => {
        state.loading = true;
      })
      .addCase(nomineeApi.fulfilled, (state, action) => {
        state.nominee = action.payload;
        state.loading = false;
      })
      .addCase(nomineeApi.rejected, (state, action) => {
        state.errors.push(action.error.message);
        state.loading = false;
      });
  },
});

export default nomineeSlice.reducer;
